import { Paper, Text, createStyles, Box } from '@mantine/core';
import React from 'react';

// Custom styles
const useStyles = createStyles((theme) => ({
	container: {
		padding: '10px 0 0px'
	},
	text: {
		fontSize: 28,
		lineHeight: '34px',
		fontWeight: 400,
		color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
	},
	cardTitle: {
		fontWeight: 600,
		fontSize: 15,
		lineHeight: '19px',
		color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
	}
}));

export default function DetailCard({ title, text, style }) {

	// State and hooks
	const { classes } = useStyles();

	return (
		<Paper
			withBorder
			p={12}
			style={style}
			radius={18}
		>
			{/* Title */}
			<Text className={classes.cardTitle}>
				{title}
			</Text>
			{/* Content */}
			<Box className={classes.container}>
				<Text className={classes.text}>
					{text}
				</Text>
			</Box>
		</Paper>
	);

}
